import { transformEnabledFacets } from '@activebrands/core-web/utils/transform-enabled-facets';
import { graphql, useStaticQuery } from 'gatsby';

const useSearchQuery = () => {
    const { application } = useStaticQuery(
        graphql`
            {
                application {
                    data {
                        config {
                            headerConfig {
                                searchNoResultText
                                searchInput
                                searchNoResultLabel
                                suggestedLabel
                            }
                            sortConfig {
                                enabledFacets {
                                    ...Facet
                                    ...FacetGroup
                                }
                            }
                            dedicatedPages {
                                searchPage
                            }
                        }
                    }
                }
            }
        `
    );

    const { headerConfig, dedicatedPages, sortConfig } = application.data.config;
    return {
        headerConfigContent: headerConfig || {},
        searchPage: dedicatedPages?.searchPage,
        enabledFacets: transformEnabledFacets(sortConfig.enabledFacets),
    };
};

export default useSearchQuery;
